import { call, put, takeEvery } from "redux-saga/effects";
import {
  loginSuccess,
  apiError,
  userpasswordchangeSuccess,
  userpasswordchangeError,
  redirect_loginSuccess,
  redirect_loginError,
} from "./actions";
import { togglePageLoader } from "../../global/actions";
import { LOGIN_USER, LOGOUT_USER, CHANGE_USER_PASSWORD, REDIRECT_LOGIN } from "./actionTypes";
//import {changePassword, redirtect_api } from "../../../helpers/api_helper";
import { postLogin } from "../../../helpers/api";
import { notifications } from '@mantine/notifications';
import toast from "toastr";

// Login Saga
function* loginUserviaapi({ payload: { data, navigate } }) {
  localStorage.removeItem("authUser");
  localStorage.setItem('token', '')
  try {
    yield put(togglePageLoader(true));
    const response = yield call(postLogin, data);
    if (response.token) {
      toast.success(response.message);
    } else {
      toast.error(response.message);
    }
    if (response.token) {
      localStorage.setItem("authUser", JSON.stringify({ ...response.user, token: response.token }));
      localStorage.setItem("userRoleId", response.user.userRoleId);
      localStorage.setItem("clientId", response.user.clientId);
      localStorage.setItem('client', JSON.stringify(response.user.client));
      localStorage.setItem("otp", response.otp);
      yield put(loginSuccess(response));
      yield put(togglePageLoader(false));
      if (response?.user?.twoFactorAuthentication) {       
        navigate("/verify");
      } else {
        if (response.user.userRoleId === 1) {
          navigate("/manageuser");
        } else if (response.user.userRoleId === 2) {
          navigate("/client");
        }
      }
    } else {
      yield put(togglePageLoader(false));
      yield put(apiError(response));
    }
  } catch (error) {
    yield put(togglePageLoader(false));
    localStorage.removeItem("authUser");
    yield put(apiError(error));
  }
}

// Logout Saga
function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("authUsers");
    localStorage.removeItem("token");
    localStorage.removeItem("userid");
    history.push("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

//Change Password Saga
// function* changepassword({ payload: data, callback }) {
//   try {
//     yield put(togglePageLoader(true));
//     const response = yield call(changePassword, data);

//     if (response.statusCode === 200) {
//       yield put(userpasswordchangeSuccess(response));
//       toast.success(response.message);
//       callback("SUCCESS");
//     } else {
//       yield put(userpasswordchangeError(response.error));
//       toast.error(response.message);
//       callback("FAILURE");
//     }
//   } catch (error) {
//     yield put(userpasswordchangeError(error));
//     toast.error(error?.response ? error.response.message : error);
//     callback("FAILURE");
//   } finally {
//     yield put(togglePageLoader(false));
//   }
// }

// Redirect Login Saga
// function* redirectLogin({ payload: { data, history } }) {
//   localStorage.removeItem("authUser");
//   localStorage.removeItem("authUsers");

//   const searchParams = new URLSearchParams(window.location.search);
//   const RedirectionUrl = searchParams.get("redirectUrl");
//   const userid = searchParams.get("userId");
//   const date = searchParams.get("date");
//   const subcategoryId = searchParams.get("subcategory");
//   const clientId = searchParams.get("clientId");
//   const accountId = searchParams.get("accountId");

//   try {
//     //yield put(togglePageLoader(true));
//     const response = yield call(redirtect_api, data);

//     if (response?.statusCode === 200) {
//       localStorage.setItem("authUser", JSON.stringify(response));
//       const suthusersss = {
//         username: response?.data?.email,
//         password: "",
//         Platform: "web",
//       };
//       localStorage.setItem("authUsers", JSON.stringify(suthusersss));
//       yield put(redirect_loginSuccess(response));

//       const redirectTo = response?.message === "Get User Data" ? "/verifyscreen" : `${RedirectionUrl}?userId=${userid}&date=${date}&subcategoryId=${subcategoryId}&accountId=${accountId}&clientId=${clientId}`;
//       history.push(redirectTo);
//     } else {
//       yield put(redirect_loginError(response.error));
//     }
//   } catch (error) {
//     toast.error("Your token is expired.");
//     yield put(redirect_loginError(error));
//   } finally {
//     yield put(togglePageLoader(false));
//   }
// }

// Root Saga
function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUserviaapi);
  yield takeEvery(LOGOUT_USER, logoutUser);
  //yield takeEvery(CHANGE_USER_PASSWORD, changepassword);
  //yield takeEvery(REDIRECT_LOGIN, redirectLogin);
}

export default authSaga;
